import { GolferStatsData } from '@/api/golfer/golfer.types.ts';
import { DefaultResponse, PaginatedApiResponse } from '@/api/shared.types.ts';
import axiosServer from '@/services/axios.ts';
import { transformToApiError } from '@/utils/error.ts';

const endpoint = '/golfer';

export const getAllGolfersStats = async (
  page: number,
  pageSize: number
): Promise<PaginatedApiResponse<GolferStatsData>> => {
  try {
    const params: Record<string, any> = { page, pageSize };

    const response = await axiosServer.get(`${endpoint}/stats`, { params });
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const deleteGolfer = async (
  golferId: string
): Promise<DefaultResponse> => {
  try {
    const response = await axiosServer.delete(`${endpoint}/${golferId}`);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};
